"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryOfOrigine_OnClick = void 0;
var Algemeen_1 = require("../Algemeen");
var pnlCountryOfOrigine;
var pceCountryOfOrigine;
var tbCountryOfOrigine;
var CountryOfOriginesAll;
//INIT
function InitCountryOfOrigine() {
    pnlCountryOfOrigine = $('#ctl00_cphBody_pnlCountryOfOrigine');
    pceCountryOfOrigine = $('ctl00_cphBody_pceCountryOfOrigine');
    tbCountryOfOrigine = $('#ctl00_cphBody_tbCountryOfOrigine');
    tbCountryOfOrigine.keyup(function (e) { tbCountryOfOrigineOnkeyup(e); });
    tbCountryOfOrigine.focus(function () { tbCountryOfOrigineOnfocus(); });
    tbCountryOfOrigine.blur(function () { tbCountryOfOrigineOnblur(); });
    pnlCountryOfOrigine.mousedown(function () { pnlCountryOfOrigineOnmousedown(); });
    CallWebServiceGetCountryOfOrigines();
}
//GET DATA
function CallWebServiceGetCountryOfOrigines() {
    $.ajax({
        type: "POST",
        url: "Aanvraag.asmx/GetCountries",
        data: "{}",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: OnSuccessGetCountryOfOrigines,
        error: Algemeen_1.OnErrorCallWebService
    });
}
function OnSuccessGetCountryOfOrigines(data, status) {
    CountryOfOriginesAll = data.d;
    fillDropDownCountryOfOrigine(data.d);
}
//FILTER DATA
function FilterAndFillCountryOfOrigine() {
    var Countries = FilterCountry(tbCountryOfOrigine.val());
    if (Countries.length == 0) {
        pceCountryOfOrigine.hidePopup();
    }
    else {
        pceCountryOfOrigine.showPopup();
    }
    fillDropDownCountryOfOrigine(Countries);
}
function FilterCountry(filter) {
    var filteredCountries = new Array();
    for (var i = 0; i < CountryOfOriginesAll.length; i++) {
        var Country = CountryOfOriginesAll[i];
        if (Country.Description.toLowerCase().indexOf(filter.toLowerCase()) != -1) {
            filteredCountries.push(Country);
        }
    }
    return filteredCountries;
}
//DROPDOWN
function fillDropDownCountryOfOrigine(CountryOfOrigines) {
    pnlCountryOfOrigine.empty();
    for (var i = 0; i < CountryOfOrigines.length; i++) {
        AddCountryOfOrigine(CountryOfOrigines[i]);
    }
}
function AddCountryOfOrigine(CountryOfOrigine) {
    pnlCountryOfOrigine.append('<div class="divDropDownItem" onclick="EntryPoint.CountryOfOrigine_OnClick(&quot;' + CountryOfOrigine.Code + '&quot;,&quot;' + CountryOfOrigine.Description + '&quot;)">' + CountryOfOrigine.Description + '</div>');
}
//EVENTS
function CountryOfOrigine_OnClick(CountryOfOrigine, Name) {
    pceCountryOfOrigine.hidePopup();
    tbCountryOfOrigine.val(Name);
}
exports.CountryOfOrigine_OnClick = CountryOfOrigine_OnClick;
function tbCountryOfOrigineOnkeyup(e) {
    FilterAndFillCountryOfOrigine();
    tbCountryOfOrigine.blur(function () { tbCountryOfOrigineOnblur(); });
}
function tbCountryOfOrigineOnblur() {
    var Countries = FilterCountry(tbCountryOfOrigine.val());
    if (Countries.length == 0) {
        tbCountryOfOrigine.val('');
    }
    else {
        tbCountryOfOrigine.val(Countries[0].Description);
    }
    pceCountryOfOrigine.hidePopup();
}
function pnlCountryOfOrigineOnmousedown() {
    tbCountryOfOrigine.off('blur');
}
function tbCountryOfOrigineOnfocus() {
    FilterAndFillCountryOfOrigine();
}
